import { render, staticRenderFns } from "./ValidatorV2.vue?vue&type=template&id=32888a9b&scoped=true&"
import script from "./ValidatorV2.vue?vue&type=script&lang=js&"
export * from "./ValidatorV2.vue?vue&type=script&lang=js&"
import style0 from "./ValidatorV2.vue?vue&type=style&index=0&id=32888a9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32888a9b",
  null
  
)

export default component.exports